import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const OfferLetter = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path
        d="M15.51 4.69008L11.5 0.810078C11.18 0.500078 10.76 0.330078 10.31 0.330078H3.62C1.62 0.330078 0 1.90008 0 3.83008V16.1701C0 18.1001 1.62 19.6701 3.62 19.6701H12.39C14.39 19.6701 16.01 18.1001 16.01 16.1701V5.84008C16.01 5.41008 15.83 4.99008 15.52 4.69008H15.51ZM10.8 2.36008L13.73 5.19008H10.8V2.36008ZM12.38 18.0701H3.62C2.51 18.0701 1.6 17.2201 1.6 16.1701V3.83008C1.6 2.78008 2.51 1.93008 3.62 1.93008H9.2V5.99008C9.2 6.43008 9.56 6.79008 10 6.79008H14.4V16.1701C14.4 17.2201 13.49 18.0701 12.38 18.0701Z"
        fill="black"
      />
      <Path
        d="M12.0004 9.18994H4.16035C3.72035 9.18994 3.36035 9.54994 3.36035 9.98994C3.36035 10.4299 3.72035 10.7899 4.16035 10.7899H12.0004C12.4404 10.7899 12.8004 10.4299 12.8004 9.98994C12.8004 9.54994 12.4404 9.18994 12.0004 9.18994Z"
        fill="black"
      />
      <Path
        d="M12.0004 13.1899H4.16035C3.72035 13.1899 3.36035 13.5499 3.36035 13.9899C3.36035 14.4299 3.72035 14.7899 4.16035 14.7899H12.0004C12.4404 14.7899 12.8004 14.4299 12.8004 13.9899C12.8004 13.5499 12.4404 13.1899 12.0004 13.1899Z"
        fill="black"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default OfferLetter
